<div class="intercation-container">
    <div class="title" *ngIf="showTitle">
        {{ 'mimic.settings.button-intercation.title' | translate }}
    </div>

    <ng-container *ngIf="shouldShowActions">
        <div class="button-actions">
            <app-button-element-actions
                [buttonAction]="buttonAction"
                (onActionSelected)="handleActionSelected($event)"></app-button-element-actions>
        </div>
    </ng-container>

    <div class="options-container">
        <app-button-disabled-state
            #disabledStateComponent
            [disabledStatus]="disabledStatus"
            [vesselId]="vesselId">
        </app-button-disabled-state>

        <app-button-flashing-state
            *ngIf="shouldShowFlashingOption"
            #flashingStateComponent
            [flashingStatus]="flashingStatus"
            [vesselId]="vesselId">
        </app-button-flashing-state>
    </div>
</div>
